// web/src/api/skip.ts — Phase 5 UI-05 audit-clean skip endpoint wrapper.
//
// Calls POST /api/sessions/:id/skip which writes an Attempt row with
// guard_reason='parent_skip' (auditable via psql -c "SELECT * FROM
// attempt WHERE guard_reason='parent_skip'") and advances the card.
//
// Phase 9: server now returns the standard TurnEnvelope shape (the same
// envelope returned by /turns), so callers consume it identically.
//
// CSRF-protected (RequireSession + DoubleSubmitCSRF inherited from
// /api/sessions sub-router in cmd/server/main.go).
import { type TurnEnvelope } from "../types/api.js";
import { withCSRF } from "./_csrf.js";

export async function postSkip(sessionId: string): Promise<TurnEnvelope> {
  const start = performance.now();
  console.info("[turn] POST /skip", { sessionId });
  const res = await fetch(`/api/sessions/${encodeURIComponent(sessionId)}/skip`, {
    method: "POST",
    credentials: "include",
    headers: withCSRF({}),
  });
  if (!res.ok) {
    console.warn("[turn] POST /skip error", {
      sessionId,
      status: res.status,
      requestId: res.headers.get("X-Request-ID") ?? undefined,
      latencyMs: Math.round(performance.now() - start),
    });
    throw new Error(`postSkip: ${res.status}`);
  }
  const env = (await res.json()) as TurnEnvelope;
  console.info("[turn] POST /skip ok", {
    sessionId,
    requestId: res.headers.get("X-Request-ID") ?? undefined,
    latencyMs: Math.round(performance.now() - start),
    actionType: env.action_type,
    nextKind: env.next_state?.kind,
    taskShortCode: env.next_state?.kind === "task" ? env.next_state.task_short_code : undefined,
  });
  return env;
}
